/**
 *
 */

var Masonry = (function($) {
  function initMasonry() {
    $(".grid").imagesLoaded(function() {
      $(".grid").masonry({
        columnWidth: ".grid__item",
        itemSelector: ".grid__item",
        percentPosition: true,
        horizontalOrder: true,
        gutter: ".grid-gutter"
      });
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".grid").length) {
      return;
    }

    initMasonry();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Masonry.init);
